<script setup lang="ts">
import { t } from '@nova/core';

const { header, testId } = defineProps<{
  header: string;
  testId?: string;
}>();

const emit = defineEmits<{
  only: [];
}>();
</script>

<template>
  <div class="d-flex align-center justify-space-between pr-2">
    <v-list-subheader :data-testid="`${testId}-group-${header}`" class="typography-body-sm-bold">
      {{ header }}
    </v-list-subheader>
    <v-btn
      class="text-none typography-button-sm"
      size="small"
      variant="text"
      :data-testid="`${testId}-group-${header}-only`"
      @click.stop="emit('only')">
      {{ t('global.basicTerms.only') }}
    </v-btn>
  </div>
</template>
